import {
  ROUTE_ACCOUNT_SETTINGS,
  ROUTE_HOME,
  ROUTE_LEGACY_PROFILE,
  ROUTE_ORDER_HISTORY,
  ROUTE_PROFILE_ACHIEVEMENTS,
} from "@/constants/routes";
import useDoesUserHaveWallets from "@/libs/apis/onboarding/user/useUserWallets/useDoesUserHaveWallets";
import { createRouteFromParams } from "@/src/helpers/createRouteWithParams";
import { getUserProfileRoute } from "@/src/helpers/getUserProfileRoute";
import { OptimizelyFeatureFlags } from "@/src/services/optimizely/optimizelyFeatureFlags";
import useIsFeatureFlagEnabled from "@/src/services/optimizely/useIsFeatureFlagEnabled";
import { noop } from "lodash";
import { signOut } from "next-auth/react";

export const useProfileMenuLinks = (swooshHandle: string | undefined) => {
  const legacyProfileFeature = useIsFeatureFlagEnabled(
    OptimizelyFeatureFlags.ENABLE_LEGACY_PROFILE,
  );
  const isLegacyProfileEnabled =
    legacyProfileFeature.clientReady && legacyProfileFeature.enabled;
  const userWallets = useDoesUserHaveWallets();
  const isUserWithWallets = userWallets !== undefined && userWallets;

  if (!!!swooshHandle) return () => {};

  const accountSettings = {
    __typename: "Link",
    text: "Account Settings",
    url: ROUTE_ACCOUNT_SETTINGS,
    onClick: () => {
      noop;
    }, // global nav page analytics event to go here
  };

  const orderHistory = {
    __typename: "Link",
    text: "Orders",
    url: ROUTE_ORDER_HISTORY,
    onClick: noop,
  };

  const logOut = {
    __typename: "Link",
    text: "Log Out",
    className: "mt-2",
    onClick: () => signOut({ callbackUrl: ROUTE_HOME }),
  };

  const achievements = {
    __typename: "Link",
    text: "Achievements",
    url: createRouteFromParams(ROUTE_PROFILE_ACHIEVEMENTS, {
      handle: swooshHandle,
    }),
    onClick: noop, // global nav page analytics event to go here
  };

  if (isLegacyProfileEnabled && isUserWithWallets) {
    return [
      accountSettings,
      orderHistory,
      achievements,
      {
        __typename: "Link",
        text: "Legacy Profile",
        url: createRouteFromParams(ROUTE_LEGACY_PROFILE, {
          handle: swooshHandle,
        }),
        onClick: noop, // global nav page analytics event to go here
      },
      logOut,
    ];
  }

  if (isLegacyProfileEnabled) {
    return [accountSettings, orderHistory, achievements, logOut];
  }

  return [
    accountSettings,
    orderHistory,
    {
      __typename: "Link",
      text: "Profile",
      url: getUserProfileRoute(swooshHandle),
      onClick: noop, // global nav page analytics event to go here
    },
    logOut,
  ];
};
